// extracted by mini-css-extract-plugin
export default {"header2":"header3_header2__8jP8M","skipMargin":"header3_skipMargin__MNNRg","wide":"header3_wide__tSU+0","placeHolderShimmer":"header3_placeHolderShimmer__imySv"};